export const marketBasketTemplateStateConstants = {
  archivedStateDisplayValue: '(Archived)'
};
